import { render } from "./programpost.vue?vue&type=template&id=936ab7b2"
import script from "./programpost.vue?vue&type=script&lang=js"
export * from "./programpost.vue?vue&type=script&lang=js"

import exportComponent from "/home/metabrain/withyou/djvue/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__